import * as React from 'react';
import withSideEffect from 'react-side-effect';

interface IStyle {
    styleText: string;
}

interface IStyleElementLegacy extends HTMLStyleElement {
    readonly styleSheet?: {
        cssText?: string;
    };
}

class HeadStyleComponent extends React.Component<IStyle, {}> {
    public render(): React.ReactNode {
        return null;
    }
}

function reducePropsToState(propsList: ReadonlyArray<IStyle>): string {
    return propsList.map(p => p.styleText).join('\r\n');
}

function handleStateChangeOnClient(css: string): void {
    if (typeof document !== 'undefined') {
        let headStyles: IStyleElementLegacy = document.getElementById(
            'react-head-styles'
        ) as HTMLStyleElement;
        if (headStyles && headStyles.parentNode) {
            headStyles.parentNode.removeChild(headStyles);
        }
        const head = document.head || document.getElementsByTagName('head')[0];
        headStyles = document.createElement('style');
        headStyles.setAttribute('id', 'react-head-styles');
        headStyles.setAttribute('type', 'text/css');
        if (headStyles.styleSheet) {
            headStyles.styleSheet.cssText = css;
        } else {
            headStyles.appendChild(document.createTextNode(css));
        }
        head.appendChild(headStyles);
    }
}
export const HeadStyle = withSideEffect(reducePropsToState, handleStateChangeOnClient)(
    HeadStyleComponent
);
// tslint:disable-next-line:no-default-export (autogenerated)
export default HeadStyle;
